import React from 'react';
import './Card.css';

const Card = ({ children, className = '', hover = true, ...props }) => {
  return (
    <div className={`rb-card ${hover ? 'rb-card-hover' : ''} ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '' }) => {
  return <div className={`rb-card-header ${className}`}>{children}</div>;
};

const CardBody = ({ children, className = '' }) => {
  return <div className={`rb-card-body ${className}`}>{children}</div>;
};

const CardFooter = ({ children, className = '' }) => {
  return <div className={`rb-card-footer ${className}`}>{children}</div>;
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
